exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal--14fEy {\n  max-width: 600px;\n}\n\n.modal-content--3owsb {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n\n.summary--EdxAg {\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.submit--3SQ-C {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.submit--3SQ-C .button--3zxqx {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"modal": "modal--14fEy",
	"modal-content": "modal-content--3owsb",
	"summary": "summary--EdxAg",
	"submit": "submit--3SQ-C",
	"button": "button--3zxqx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/emission/cards/controls/CardStatusControl/CardStatusControl.m.scss
// module id = 1377
// module chunks = 0